import { Table } from "antd";
import useLL84Table from "hooks/Litigation/useLL84Table";
const LL84Table = () => {
  const { data, columns } = useLL84Table();
  return (
    <>
      <div style={{ padding: "20px" }}>
        <Table columns={columns} dataSource={data} size="middle" />
      </div>
    </>
  );
};

export default LL84Table;
